export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_TELEPHONE = "SET_TELEPHONE";
export const SET_EMAIL_ADDRESS = "SET_EMAIL_ADDRESS";
export const SET_TERMS_AND_CONDITIONS = "SET_TERMS_AND_CONDITIONS";
export const SET_PRIVACY_POLICY = "SET_PRIVACY_POLICY";

export const initialState = {
  loading: true,
  entryFormDetails: {},
};

export const toggleLoading = () => ({
  type: TOGGLE_LOADING,
});

export const setFirstName = (firstName) => ({
  type: SET_FIRST_NAME,
  firstName,
});

export const setLastName = (lastName) => ({
  type: SET_LAST_NAME,
  lastName,
});

export const setTelephone = (telephone) => ({
  type: SET_TELEPHONE,
  telephone,
});

export const setEmailAddress = (emailAddress) => ({
  type: SET_EMAIL_ADDRESS,
  emailAddress,
});

export const setTermsAndConditions = (termsAndConditions) => ({
  type: SET_TERMS_AND_CONDITIONS,
  termsAndConditions,
});

export const setPrivacyPolicy = (privacyPolicy) => ({
  type: SET_PRIVACY_POLICY,
  privacyPolicy,
});

// eslint-disable-next-line complexity
export const entryFormDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case SET_FIRST_NAME:
      return {
        ...state,
        entryFormDetails: {
          ...state.entryFormDetails,
          firstName: action.firstName,
        },
      };
    case SET_LAST_NAME:
      return {
        ...state,
        entryFormDetails: {
          ...state.entryFormDetails,
          lastName: action.lastName,
        },
      };
    case SET_TELEPHONE:
      return {
        ...state,
        entryFormDetails: {
          ...state.entryFormDetails,
          telephone: action.telephone,
        },
      };
    case SET_EMAIL_ADDRESS:
      return {
        ...state,
        entryFormDetails: {
          ...state.entryFormDetails,
          emailAddress: action.emailAddress,
        },
      };
    case SET_TERMS_AND_CONDITIONS:
      return {
        ...state,
        entryFormDetails: {
          ...state.entryFormDetails,
          termsAndConditions: action.termsAndConditions,
        },
      };
    case SET_PRIVACY_POLICY:
      return {
        ...state,
        entryFormDetails: {
          ...state.entryFormDetails,
          privacyPolicy: action.privacyPolicy,
        },
      };
    default:
      return state;
  }
};
